<template>
  <TableList
    v-rect-loading="loading"
    class="notification-template-list"
    noHeadBtn
    :listData="tableData"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
  >
    <template #filter>
      <el-select
        v-model="searchTemplateType"
        clearable
        class="el-select keywords-filter"
        :placeholder="$t(`${i18nPrefix}.label.searchTemplateType`)"
        @change="formatSearchData"
      >
        <el-option
          v-for="item in templateTypeOptions"
          :key="item.index"
          :label="item.templateTypeName"
          :value="item.template_type_name"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="searchTemplateName"
        clearable
        class="el-input keywords-filter"
        :placeholder="$t(`${i18nPrefix}.label.searchTemplateName`)"
        @input="handleKeywordsChange"
      ></el-input>
    </template>
  </TableList>
</template>
<script>
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import _ from 'lodash'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.notification',
      searchTemplateName: null,
      searchTemplateType: null,
      templateTypeOptions: [],
      tableData: []
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.templateType`),
          dataKey: 'templateTypeName'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateName`),
          dataKey: 'name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.receiverLimit`),
          dataKey: 'receiver_limit'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: true,
          onclick: this.handleEdit
        },
        view: {
          show: true,
          labelI18nKey: 'common.btn.view',
          onclick: this.handleView
        }
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('notificationTemplate', ['searchSystemTemplate']),
    handleEdit (row) {
      this.$router.push({
        path: `/v-admin/system-notification-template-management/edit/${row.id}`,
        query: this.$route.query
      })
    },
    handleView (row) {
      this.$router.push({
        path: `/v-admin/system-notification-template-management/view/${row.id}`,
        query: this.$route.query
      })
    },
    async initData () {
      this.loading = true
      try {
        await Promise.all([
          this.handleSearchTemplate(),
          this.initTemplateDropdown()
        ])
      } finally {
        this.loading = false
      }
    },
    async initTemplateDropdown () {
      const resp = await this.searchSystemTemplate()
      this.templateTypeOptions = _.map(resp, (data) => {
        addI18nProperty(data, 'templateTypeName', 'template_type_name_cn', 'template_type_name_en')
        return data
      })
    },
    async handleSearchTemplate () {
      this.parseQuery()
      const params = {
        search_template_name: this.searchTemplateName,
        search_template_type: this.searchTemplateType
      }
      if (!this.loading) {
        this.$eventBus.$emit('showLoading', true)
      }
      try {
        const resp = await this.searchSystemTemplate(params)
        if (resp) {
          this.tableData = _.map(resp, (row) => {
            addI18nProperty(row, 'templateTypeName', 'template_type_name_cn', 'template_type_name_en')
            return row
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.formatSearchData, 1000)
      }
      this.keywordsSearchDebounce()
    },
    formatSearchData () {
      this.$router.push({
        query: {
          ...this.$route.query,
          type: this.searchTemplateType,
          name: this.searchTemplateName
        }
      })
    },
    parseQuery () {
      this.searchTemplateName = this.$route.query.name
      this.searchTemplateType = this.$route.query.type
    }
  },
  watch: {
    $route: {
      handler () {
        this.handleSearchTemplate()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notification-template-list {
  .title {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .keywords-filter {
    width: 190px;
  }

  .header-btn {
    padding: 9px 20px;
    margin-left: 10px;
  }

  .el-button {
    border: 0;
  }

  .operate-btn {
    padding: 0;
  }
}
</style>
